import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0faef30f = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _6e0af502 = () => interopDefault(import('../../../pages/dienstleistungen/index.vue' /* webpackChunkName: "pages/dienstleistungen/index" */))
const _792c6d37 = () => interopDefault(import('../../../pages/blog/_id.vue' /* webpackChunkName: "pages/blog/_id" */))
const _02764fea = () => interopDefault(import('../../../pages/dienstleistungen/_id.vue' /* webpackChunkName: "pages/dienstleistungen/_id" */))
const _2e0860c0 = () => interopDefault(import('../../../pages/_id.vue' /* webpackChunkName: "pages/_id" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blog/",
    component: _0faef30f,
    pathToRegexpOptions: {"strict":true},
    name: "blog___de___default"
  }, {
    path: "/de/",
    component: _0547af50,
    pathToRegexpOptions: {"strict":true},
    name: "index___de"
  }, {
    path: "/dienstleistungen/",
    component: _6e0af502,
    pathToRegexpOptions: {"strict":true},
    name: "dienstleistungen___de___default"
  }, {
    path: "/de/blog/",
    component: _0faef30f,
    pathToRegexpOptions: {"strict":true},
    name: "blog___de"
  }, {
    path: "/de/dienstleistungen/",
    component: _6e0af502,
    pathToRegexpOptions: {"strict":true},
    name: "dienstleistungen___de"
  }, {
    path: "/de/blog/:id/",
    component: _792c6d37,
    pathToRegexpOptions: {"strict":true},
    name: "blog-id___de"
  }, {
    path: "/de/dienstleistungen/:id/",
    component: _02764fea,
    pathToRegexpOptions: {"strict":true},
    name: "dienstleistungen-id___de"
  }, {
    path: "/blog/:id/",
    component: _792c6d37,
    pathToRegexpOptions: {"strict":true},
    name: "blog-id___de___default"
  }, {
    path: "/de/:id/",
    component: _2e0860c0,
    pathToRegexpOptions: {"strict":true},
    name: "id___de"
  }, {
    path: "/dienstleistungen/:id/",
    component: _02764fea,
    pathToRegexpOptions: {"strict":true},
    name: "dienstleistungen-id___de___default"
  }, {
    path: "/",
    component: _0547af50,
    pathToRegexpOptions: {"strict":true},
    name: "index___de___default"
  }, {
    path: "/:id/",
    component: _2e0860c0,
    pathToRegexpOptions: {"strict":true},
    name: "id___de___default"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
